import React from 'react';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { TableContainer, TableCell, TableRow, Table, TableBody, TableHead } from '@mui/material';
import PropTypes from 'prop-types';
import FinancedOffersAssetInformationItemComponent from './FinancedOffersAssetInformationItemComponent';

export const FinancedOffersAssetInformationListItemComponent = ({
  t,
  asset,
  offerId,
  offerSiteId,
  canGenerateContract,
  selectAssetsForContractGeneration,
  assetId
}) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('Document.ContractGeneration.Selected')}</TableCell>
            <TableCell>{t('Document.ContractGeneration.OrderNo')}</TableCell>
            <TableCell>{t('Document.ContractGeneration.ChassisNumber')}</TableCell>
            <TableCell>{t('Document.ContractGeneration.ContractNumber')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {asset.assetsAdditionalInformation.map((assetAdditionalInformation, key) => {
            return (
              <FinancedOffersAssetInformationItemComponent
                key={key}
                assetAdditionalInformation={assetAdditionalInformation}
                offerId={offerId}
                offerSiteId={offerSiteId}
                assetId={assetId}
                selectAssetsForContractGeneration={selectAssetsForContractGeneration}
                canGenerateContract={canGenerateContract}
                selected={
                  assetAdditionalInformation.contractNumber
                    ? false
                    : assetAdditionalInformation.selected
                    ? assetAdditionalInformation.selected
                    : false
                }
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

FinancedOffersAssetInformationListItemComponent.propTypes = {
  asset: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  offerId: PropTypes.number.isRequired,
  offerSiteId: PropTypes.number.isRequired,
  assetId: PropTypes.number.isRequired,
  canGenerateContract: PropTypes.bool.isRequired,
  selectAssetsForContractGeneration: PropTypes.func.isRequired
};

export default compose(withTranslation())(FinancedOffersAssetInformationListItemComponent);
